import ReusableModal from "./ReusableModal"
import { LuSquareArrowOutUpRight } from "react-icons/lu"
import useStore from "../../store"
import { useState } from "react"

export default function TosModal({ isOpen, onClose, onOpen, handleAccept }) {
  const user = useStore((state) => state.user)
  const acceptingTermsOfService = useStore((state) => state.acceptingTermsOfService)

  const handleClick = () => {
    window.open("https://floorplanxpress.com/terms", "_blank", "noopener,noreferrer")
  }
  return(
    <ReusableModal
      isOpen={!user.accepted_new_terms_at}
      headerText="Terms of Service"
      submitText="Accept"
      handleSubmit={handleAccept}
      dataTestId="dealer-tos-modal"
      loading={acceptingTermsOfService}
    >
      <p>
        Please review the updated Terms of Service. By clicking "Accept," you confirm that you have read and agree to the Terms of Service.
      </p>
      <p className="pt-4 flex items-center gap-1 cursor-pointer" data-testid="tos-link" onClick={handleClick}>
        Terms of Service
        <LuSquareArrowOutUpRight/>
      </p>
    </ReusableModal>
  )
}